export default __webpack_public_path__ + "static/media/pac-correios-logo-8.cc6e1eda.png";